<template>
<div>

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<!--
  <div class="form-group form-check">
    <input type="checkbox" class="form-check-input pointer" id="exampleCheck1" v-model="xml_type">
    <label class="form-check-label" for="exampleCheck1">SCONTRINO DI CORTESIA</label>
  </div>  
-->
</div>

</template>

<script>

import { mapGetters } from 'vuex';
//import axios from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'

  export default {
  props : ['url','data','giftTicket'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
          code     : ''                            
      }
    },

    
    computed: {
     ...mapGetters(['company']),
      
    },
    
    created () 
      {
        
      },
    
    methods: 
    {
     

     clickHandler() 
     {
         console.log('XON_XOFF')
         //let data = []
         let total_discount = 0
         let round_total = 0
         let payments = []
         let csvContent = "data:text/csv;charset=utf-8," 
         let data_item = ''

         if(this.data.data)
         {


            if(this.giftTicket)
            {
                         
             data_item = 'j' +"\r\n"
             csvContent += data_item
                         
             data_item = '"       SCONTRINO DI CORTESIA"1@' + "\r\n"
             csvContent += data_item

             data_item  = '"' +  'S' + this.data.saleId + '"3B' +  "\r\n"
             csvContent += data_item
             
             data_item = 'J' +  "\r\n"
             csvContent += data_item

      

            }
            else
            {
            if(this.data.lottery)
            {
                
              data_item = '"' + this.data.lottery + '"'  + '@38F'  
              csvContent += data_item + "\r\n";  
               

            } 
            
            this.data.data[0].forEach(item => {

                total_discount = item.total_discount
                round_total = item.round_total
                // ITEM DISCOUNT  
                
                if(Number(item.discount)>0)
                {
                  data_item = '"' + item.barcode + ' ' + item.category + '"' + item.price + 'H1R'  
                  csvContent += data_item + "\r\n";
                  
                  data_item =  + item.discount + '*1M'  
                  //data_item =  + item.discount + '.00' + '*1M'  

                  csvContent += data_item + "\r\n";
                }
                else
                {
                  data_item = '"' + item.barcode + ' ' + item.category + '"' + item.total_row + 'H1R'  
                  csvContent += data_item + "\r\n";
                }
                

             
            });
           
                        
            payments = this.data.data[1]
            

            data_item = '40F'  
            csvContent += data_item + "\r\n";
            
            if(Number(total_discount)>0)
            {
              data_item = '=' + total_discount + 'H4M'   
              csvContent += data_item + "\r\n";  
            }
            if(Number(round_total)>0)
            {
              data_item = '=' + round_total + 'H8M'   
              csvContent += data_item + "\r\n";  
            }

            const total_elec =   payments.filter(item => item.typeId == 'ELEC') 
            payments.forEach(item=>{
                if(item.typeId == 'CASH')
                
                {
                    data_item = item.total  + 'H1T';
                    csvContent += data_item + "\r\n";

            
                }
                /*
                if(item.typeId == 'ELEC')
                {
                    data_item = item.total  + 'H3T';
                    csvContent += data_item + "\r\n";

                    
                }
                */
                if(item.typeId == 'CRED' || item.typeId == 'PAGO' || item.typeId == 'SCAL')
                {
                   data_item = item.total  + 'H5T';
                   csvContent += data_item + "\r\n";
                }

            })

            let total = 0
            total_elec.forEach(item=>{
                total += item.total
            })  
            if(total > 0)
            {
              data_item = total  + 'H3T';
              csvContent += data_item + "\r\n";
            }

              data_item = '41F'
              csvContent += data_item
              csvContent += '"' +  'S' + this.data.saleId + '"3B' +  "\r\n"
              data_item = '42F'
              csvContent += data_item
              
            }

            
         }
            
            
            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "scontrino.txt");

            

            link.click(); // 
            this.$emit('finish')
   
     } 
      

    }
  }
</script>
<style scoped>





 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
